module.exports = __webpack_public_path__ + "static/media/Comments.b4c1776f.svg";